import { formatInTimeZone, fromZonedTime } from 'date-fns-tz';
import { ptBR } from 'date-fns/locale';

/** Datas locais da barbearia trafegam como AAAA-MM-DD; instantes como ISO UTC. */
export const ymdOf = (iso: string | Date, tz: string) => formatInTimeZone(iso, tz, 'yyyy-MM-dd');
export const todayYmd = (tz: string) => ymdOf(new Date(), tz);

export function addDays(ymd: string, n: number): string {
  const [y, m, d] = ymd.split('-').map(Number) as [number, number, number];
  return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10);
}

export function weekdayOf(ymd: string): number {
  const [y, m, d] = ymd.split('-').map(Number) as [number, number, number];
  return new Date(Date.UTC(y, m - 1, d)).getUTCDay();
}

/** Segunda-feira da semana da data. */
export function startOfWeek(ymd: string): string {
  const wd = weekdayOf(ymd);
  return addDays(ymd, wd === 0 ? -6 : 1 - wd);
}

export function startOfMonth(ymd: string): string {
  return `${ymd.slice(0, 7)}-01`;
}

export function addMonths(ymd: string, n: number): string {
  const [y, m] = ymd.split('-').map(Number) as [number, number];
  const d = new Date(Date.UTC(y, m - 1 + n, 1));
  return d.toISOString().slice(0, 10);
}

/** Início do dia local em ISO UTC. */
export const dayStartIso = (ymd: string, tz: string) => fromZonedTime(`${ymd}T00:00:00`, tz).toISOString();
export const localIso = (ymd: string, hhmm: string, tz: string) => fromZonedTime(`${ymd}T${hhmm}:00`, tz).toISOString();

/** Minutos desde 00:00 local. */
export function minutesOfDay(iso: string | Date, tz: string): number {
  const [h, m] = formatInTimeZone(iso, tz, 'HH:mm').split(':').map(Number) as [number, number];
  return h * 60 + m;
}

export const hhmm = (min: number) => `${String(Math.floor(min / 60)).padStart(2, '0')}:${String(min % 60).padStart(2, '0')}`;
export const timeToMin = (t: string) => Number(t.slice(0, 2)) * 60 + Number(t.slice(3, 5));

const parse = (ymd: string) => {
  const [y, m, d] = ymd.split('-').map(Number) as [number, number, number];
  return new Date(Date.UTC(y, m - 1, d, 12));
};
export const labelDay = (ymd: string, pattern = "EEEE, d 'de' MMMM") => formatInTimeZone(parse(ymd), 'UTC', pattern, { locale: ptBR });
export const labelShort = (ymd: string) => formatInTimeZone(parse(ymd), 'UTC', 'EEE d', { locale: ptBR });
export const labelMonth = (ymd: string) => formatInTimeZone(parse(ymd), 'UTC', "MMMM 'de' yyyy", { locale: ptBR });

/** Semanas (segunda a domingo) que cobrem o mês da data. */
export function monthWeeks(ymd: string): string[][] {
  const first = startOfMonth(ymd);
  const last = addDays(addMonths(first, 1), -1);
  const weeks: string[][] = [];
  let cursor = startOfWeek(first);
  while (cursor <= last) {
    weeks.push(Array.from({ length: 7 }, (_, i) => addDays(cursor, i)));
    cursor = addDays(cursor, 7);
  }
  return weeks;
}
